import Vue from 'vue'

const state = {
  dragDropObj: null,
  cancelUnchecked: false
}

const get = key => (state) => {
  return state[key]
}
const set = key => (state, val) => {
  state[key] = val
}

const getters = {
  dragDropObj: get('dragDropObj'),
  cancelUnchecked: get('cancelUnchecked')
}

const actions = {
  // Informa que um drag and drop foi iniciado
  startDragDrop ({ commit }, initialDragDropObj) {
    commit('CREATE_DRAGGINGOBJ', initialDragDropObj)
  },

  isUnchecked ({ commit }, cancelUnchecked) {
    commit('SET_CANCEL', cancelUnchecked)
  },

  // Informa qual cartão está sendo movido
  addCardToDraggingObj ({ commit }, card) {
    commit('SET_CARD', card)
  },

  // Informa de onde o cartão está foi movido
  addFromOrderToDraggingObj ({ commit }, fromOrder) {
    commit('SET_FROMOREDER', fromOrder)
  },

  // Informa para onde o cartão está sendo movido
  addToOrderToDraggingObj ({ commit }, toOrder) {
    commit('SET_TOORDER', toOrder)
  },

  // Cancela uma ação de dra and drop
  cancelDragDrop ({ commit, rootState }) {
    commit('CANCEL_DRAGGINGOBJ', rootState['board'].lists)
  },

  // Informa que uma ação de drag and drop foi finalizada
  endDragDrop ({ commit, rootState }) {
    commit('DESTROY_DRAGGINGOBJ', rootState['board'].lists)
  }
}

const mutations = {

  CREATE_DRAGGINGOBJ: set('dragDropObj'),

  SET_CANCEL: set('cancelUnchecked'),

  SET_CARD (state, card) {
    state.dragDropObj.card = card
  },

  SET_FROMOREDER (state, fromOrder) {
    state.dragDropObj.fromOrder = fromOrder
  },

  SET_TOORDER (state, toOrder) {
    state.dragDropObj.toOrder = toOrder
  },

  CANCEL_DRAGGINGOBJ (state, lists) {
    let dragObj = state.dragDropObj
    for (let i = 0; i < lists.length; i++) {
      var each = lists[i]
      if (each.id === Number.parseInt(dragObj.toList)) {
        let index = each.cards.findIndex(find => find.id === dragObj.card.id)
        each.cards.splice(index, 1)
      } else if (each.id === Number.parseInt(dragObj.fromList)) {
        each.cards.push(dragObj.card)
      }
    }
  },

  DESTROY_DRAGGINGOBJ (state, lists) {
    if (state.dragDropObj) {
      let dragObj = state.dragDropObj

      if (dragObj.fromList && dragObj.toList && dragObj.fromList !== dragObj.toList) {
        let from = lists.find(find => find.id === Number.parseInt(dragObj.fromList))
        let index = from.cards.findIndex(fIndex => fIndex.id === dragObj.card.id)
        from.cards.splice(index, 1)
        Vue.set(from, 'cards', from.cards)
        Vue.set(from, 'totalCards', from.totalCards - 1)

        let to = lists.find(find => find.id === Number.parseInt(dragObj.toList))
        to.cards.push(dragObj.card)
        Vue.set(to, 'cards', to.cards)
        Vue.set(to, 'totalCards', to.totalCards + 1)
      }
    }
    state.dragDropObj = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
